/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-12 15:06:43
 * @LastEditTime: 2022-01-18 12:08:13
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/YLSharingPayOrderSummaryList/components/YLSharingPayOrderSummaryDataOrderListModal.jsx
 */
import React, { useState, useRef } from 'react'
import { Button, Modal } from 'antd';
import TableHelper from '../../../../components/TableHelper';
import { fetchPlatformRecordYlSharingPayOrderSummaryDataOrderList } from '../../../../services/platformAccountingRecord';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { findDict, formatTime } from '../../../../utils';
import YLSharingPayOrderSummaryDataOrderDetail from './YLSharingPayOrderSummaryDataOrderDetailModal';
import { mapTradeType } from '../../../../axios/dictionaries';

const YLSharingPayOrderSummaryDataOrderList = (props) => {

    const [visible, setVisible] = useState(false);
    const [id, setId] = useState(null);
    let YLSharingPayOrderSummaryDataOrderDetailRef = useRef()
    const open = (id) => {
        setId(id)
        setVisible(true)
    }
    const close = () => {
        setVisible(false)
    }
   
    props.getRef && props.getRef({ open });
    const columns = [
        { title: '交易时间', dataIndex: 'tradingTime ', width: 140, render: (text, record) => {return formatTime(record.tradingTime,"YYYY-MM-DD")}},
        { title: '商户名称', dataIndex: 'merchantName', width: 140, },
        { title: '交易金额', dataIndex: 'tradeAmount', width: 100, },
        { title: '手续费', dataIndex: 'serviceCharge', width: 100, },
        { title: '交易净额', dataIndex: 'tradeNetAmount', width: 100, },
        { title: '可划付金额', dataIndex: 'transferableAmount', width: 100, },
        { title: '划付中金额', dataIndex: 'transferInProgressAmount', width: 100, },
        { title: '已划付金额', dataIndex: 'transferredAmount', width: 100, },
        { title: '收单方代码', dataIndex: 'acquirerCode', width: 140, },
        { title: '退货中金额', dataIndex: 'amountInReturn', width: 140, },
        { title: '卡类型', dataIndex: 'cardType', width: 140, },
        { title: '清算收单方代码', dataIndex: 'clearingAcquirerCode', width: 140, },
        { title: '创建时间', dataIndex: 'createTime', width: 140, render: formatTime},
        { title: '客户号', dataIndex: 'customerNumber', width: 140, },
        { title: '分账金额', dataIndex: 'dividedAmount', width: 140, },
        { title: '企业用户号', dataIndex: 'enterpriseUserNumber', width: 140, },
        { title: '清算日期', dataIndex: 'liquidationDate', width: 140, render: formatTime},
        { title: '商户集团编号', dataIndex: 'merchantGroupNumber', width: 140, },
        { title: '商户多应用类型', dataIndex: 'merchantMultiApplicationType', width: 140, render: (text) => text},
        { title: '商户订单号', dataIndex: 'merchantOrderNo', width: 140, },
        { title: '机构编号', dataIndex: 'orgNo', width: 140, },
        { title: '原交易参考号', dataIndex: 'originalReferenceNumber', width: 140, },
        { title: '原交易金额', dataIndex: 'originalTradeAmount', width: 140, },
        { title: '原交易日期', dataIndex: 'originalTradingTime', width: 140, formatTime},
        { title: '参考号', dataIndex: 'referenceNumber', width: 140, },
        { title: '备注信息', dataIndex: 'remark', width: 140, },
        { title: '可退货金额', dataIndex: 'returnableAmount', width: 140, },
        { title: '已退货金额', dataIndex: 'returnedAmount', width: 140, },
        { title: '流水号', dataIndex: 'serialNumber', width: 140, },
        { title: '结算商户编号', dataIndex: 'settlementMerchantNumber', width: 140, },
        { title: '银商订单号', dataIndex: 'silverMerchantOrderNo', width: 140, },
        { title: '挂账流水标记', dataIndex: 'standingBookMark', width: 140, },
        { title: '终端号', dataIndex: 'terminalNumber', width: 140, },
        { title: '交易类型', dataIndex: 'tradeType', width: 140, render: (text) => {
            return findDict(mapTradeType, text).title
        }},

        { title: '操作', dataIndex: 'actions', width: 70, fixed: 'right', render: (text, record) => {
            return <a onClick={() => YLSharingPayOrderSummaryDataOrderDetailRef.open(record.id)}>详情</a>
        }}
    ]
    const parseRequestData = (data) => {
        data.summaryDataId = id
        return data
    }
    return (
        <Modal
            visible={visible}
            width={950}
            title="汇总数据订单明细数据"
            destroyOnClose
            footer={<Button onClick={close}>关闭</Button>}
            onCancel={close}
        >
            <ModalScrollContainer>
                {id && (
                    <TableHelper 
                        columns={columns} 
                        scroll={{x: 3000}}
                        parseRequestData={parseRequestData} 
                        request={fetchPlatformRecordYlSharingPayOrderSummaryDataOrderList}  
                    />
                )}

            </ModalScrollContainer>
            <YLSharingPayOrderSummaryDataOrderDetail getRef={ref => YLSharingPayOrderSummaryDataOrderDetailRef = ref} />
        </Modal>
    )
}

export default YLSharingPayOrderSummaryDataOrderList


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/YLSharingPayOrderSummaryList/components/YLSharingPayOrderSummaryDataOrderListModal.jsx